import { render, staticRenderFns } from "./ParkingSpacesPage.vue?vue&type=template&id=2084ed80&scoped=true"
import script from "./ParkingSpacesPage.vue?vue&type=script&lang=js"
export * from "./ParkingSpacesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2084ed80",
  null
  
)

export default component.exports